/**
 * Detect fn
 */
export default () =>
  'AbortController' in self && typeof self.AbortController === 'function'
